import I18N from '@leverege/i18n';
const {
  t
} = I18N.ns('molten.imagine.forms.Uploader');
function exportCSV(data = [], columns = [], fileName = 'export.csv') {
  if (!fileName) {
    return;
  }
  let csvText = '';
  const attributes = {};
  columns.forEach((column, index) => {
    const prefix = index !== 0 ? ',' : '';
    const suffix = index === columns.length - 1 ? '\n' : '';
    if (column.attribute) {
      const attr = column.attribute;
      attributes[column.id] = attr;
      csvText += `${prefix}${attr.displayName}${suffix}`;
    } else {
      csvText += `${prefix}${column.Header}${suffix}`;
    }
  });
  data.forEach(row => {
    columns.forEach((column, index) => {
      const prefix = index !== 0 ? ',' : '';
      const suffix = index === columns.length - 1 ? '\n' : '';
      const attr = attributes[column.id];
      if (attr) {
        let value = attr.get(row.data);
        value = value?.value ? `${value.value} ${value.unit}` : value;
        const formatted = value != null ? value : '--';
        csvText += `${prefix}${formatted}${suffix}`;
      } else {
        if (typeof column.accessor === 'function') {
          csvText += `${prefix}${column.accessor(row)}${suffix}`;
        }
        if (typeof column.accessor === 'string') {
          csvText += `${prefix}${row[column.accessor]}${suffix}`;
        }
      }
    });
  });
  exportFile(csvText, fileName);
}
async function exportFile(csv, fileName) {
  const blob = new Blob([csv], {
    type: 'text/plain'
  });
  const url = URL.createObjectURL(blob);
  saveAs(url, fileName);
}
function saveAs(uri, fileName) {
  const link = document.createElement('a');
  if (typeof link.download === 'string') {
    document.body.appendChild(link); // Firefox requires the link to be in the body
    link.download = fileName;
    link.href = uri;
    link.click();
    document.body.removeChild(link); // remove the link when done
  } else {
    location.replace(uri); // eslint-disable-line no-restricted-globals
  }
}
function sanitizeCsv(csv) {
  let p = '',
    row = [''],
    i = 0,
    r = 0,
    s = !0;
  const ret = [row];
  for (let j = 0; j < csv.length; j++) {
    let char = csv[j];
    if (char === '"') {
      if (s && char === p) row[i] += char;
      s = !s;
    } else if (char === ',' && s) {
      ++i;
      row[i] = '';
      char = row[i];
    } else if (char === '\n' && s) {
      if (p === '\r') row[i] = row[i].slice(0, -1);
      ++r;
      ret[r] = [char = ''];
      row = ret[r];
      i = 0;
    } else {
      row[i] += char;
    }
    p = char;
  }
  return ret;
}
function csvToJson(csv) {
  const result = [];
  const rows = sanitizeCsv(csv);
  const headers = getHeaders(rows, true);
  for (let i = 1; i < rows.length; i++) {
    const row = rows[i];
    const obj = {};
    for (let j = 0; j < headers.length; j++) {
      obj[headers[j]] = row[j]?.trim().replaceAll('\r', '').replaceAll('\n', '');
    }
    result.push(obj);
  }
  return result;
}
function getHeaders(csv, isSanitized = false) {
  const rows = isSanitized ? csv : sanitizeCsv(csv);
  const headers = rows[0].map(h => h?.trim().replaceAll('\r', '').replaceAll('\n', ''));
  const seen = {};
  for (let i = 0; i < headers.length; i++) {
    seen[headers[i]] = seen[headers[i]] != null ? seen[headers[i]] + 1 : 1;
    if (seen[headers[i]] > 1) {
      headers[i] = t('copyHeader', {
        header: headers[i],
        count: seen[headers[i]]
      });
    }
  }
  return headers;
}
export default {
  exportFile,
  exportCSV,
  csvToJson,
  getHeaders
};